import LogActivityPage from "./LogActivityPage";

export default LogActivityPage;